(function (Drupal, once) {
  Drupal.behaviors.moveToc = {
    attach(context) {
      once('move-toc', '.block-toc-js', context).forEach((toc) => {

        const articleTitle = document.querySelector('.block-page-title-block');
        const sidebar = document.querySelector('.region-sidebar-second');

        function moveToc() {
          if (window.innerWidth <= 1400) {
            articleTitle.after(toc);
          } else {
            sidebar.appendChild(toc);
          }
        }

        moveToc();
        window.addEventListener('resize', moveToc);
      });
    }
  };
})(Drupal, once);